<template lang="pug">
menu-item(:label=`$t('embedded_hscmap')`, v-model="module.show")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { IframeModule } from "@/modules/IframeModule";

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: IframeModule
}
</script>

<i18n>
en:
  embedded_hscmap: Embedded hscMap
ja:
  embedded_hscmap: 埋め込みスニペット

</i18n>